/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserAlertNotificationSetting } from '../../models/user-alert-notification-setting';

export interface GetSetting_4$Params {
  settingId: number;
}

export function getSetting_4(http: HttpClient, rootUrl: string, params: GetSetting_4$Params, context?: HttpContext): Observable<StrictHttpResponse<UserAlertNotificationSetting>> {
  const rb = new RequestBuilder(rootUrl, getSetting_4.PATH, 'get');
  if (params) {
    rb.path('settingId', params.settingId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserAlertNotificationSetting>;
    })
  );
}

getSetting_4.PATH = '/api/user/notification/alert/setting/id/{settingId}';
